import {
  Outlet,
  createRootRoute,
  HeadContent,
  Scripts,
} from '@tanstack/react-router'
import { useEffect } from 'react'
import appCss from '../styles.css?url'
import { applyTheme, type ThemeId } from '#/lib/themes'

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover',
      },
      { name: 'theme-color', content: '#2E7D32' },
      { name: 'apple-mobile-web-app-capable', content: 'yes' },
      { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
    ],
    links: [
      { rel: 'stylesheet', href: appCss },
      { rel: 'manifest', href: '/site.webmanifest' },
      { rel: 'icon', type: 'image/svg+xml', href: '/icon.svg' },
    ],
  }),
  component: RootComponent,
})

function RootComponent() {
  useEffect(() => {
    try {
      const savedTheme = localStorage.getItem('cric_theme') as ThemeId
      if (savedTheme) {
        applyTheme(savedTheme)
      }
    } catch {
      // fallback
    }
  }, [])

  return (
    <html lang="en">
      <head>
        <HeadContent />
        <script
          dangerouslySetInnerHTML={{
            __html: `
              try {
                var t = localStorage.getItem('cric_theme');
                if (t === 'midnight-dark') {
                  document.documentElement.classList.add('dark');
                  document.documentElement.setAttribute('data-theme', 'midnight-dark');
                } else {
                  document.documentElement.classList.remove('dark');
                  if (t) {
                    document.documentElement.setAttribute('data-theme', t);
                  }
                }
              } catch(e) {}
            `,
          }}
        />
      </head>
      <body className="bg-gray-100 min-h-screen flex justify-center">
        <div className="w-full max-w-md min-h-screen bg-[var(--theme-bg,#f5f6f8)] text-[var(--theme-text,#1a1a1a)] flex flex-col relative shadow-xl overflow-x-hidden transition-colors">
          <Outlet />
        </div>
        <Scripts />
      </body>
    </html>
  )
}
